import clsx from 'clsx';
import { FunctionComponent } from 'react';
import { makeStyles } from 'tss-react/mui';

import { useIsAssemblyBrandEnabled } from 'src/hooks/useIsAssemblyBrandEnabled';
import { RegularCardBox } from 'src/legacy/components/Cards/RegularCardBox';
import { white } from 'src/theme/colors';
import { AdminCardShadow } from 'src/theme/shadows';

const ONBOARDING_FORM_WIDTH = 416;
const useStyles = makeStyles<{ isAssemblyBrandEnabled: boolean }>()(
  (theme, { isAssemblyBrandEnabled }) => ({
    root: {
      padding: theme.spacing(5, 3.5),
      borderRadius: 0,
      boxShadow: isAssemblyBrandEnabled ? 'none' : AdminCardShadow,
      backgroundColor: white,
      width: ONBOARDING_FORM_WIDTH,
      margin: 'auto',
      // on mobile screen, the onboarding card has no
      // border and shadow
      [theme.breakpoints.down('xs')]: {
        border: 'none',
        boxShadow: 'none',
        width: '100%',
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(2),
      },
    },
  }),
);

interface OnboardingCardProps {
  children?: React.ReactNode;
  className?: string;
}

export const OnboardingFormCard: FunctionComponent<OnboardingCardProps> = ({
  children,
  className,
}) => {
  const { isAssemblyBrandEnabled } = useIsAssemblyBrandEnabled();
  const { classes } = useStyles({ isAssemblyBrandEnabled });

  return (
    <RegularCardBox
      className={clsx(classes.root, className)}
      shouldHideBorder={isAssemblyBrandEnabled}
    >
      {children}
    </RegularCardBox>
  );
};
